import { getLink } from '../../../utils/utils';

import abiNaskiĝisEnArbar from './abi_naskiĝis_en_arbar';
import diruHoMiaBela from './diru_ho_mia_bela';
import erinaco from './erinaco';
import himnoDeOdesaHumurfesto from './himno_de_odesa_humurfesto';
import juKukin from './ju_kukin';
import juVizbor from './ju_vizbor';
import kantoPriOdeso90 from './kantoj_pri_odeso_de_90aj';
import kantoPriOdeso from './kanto_pri_odeso';
import radoDeLaFortun from './kanto_laŭ_la_melodio_staraja_melnica';
import kantojElAventurojDeBuratino from './kanto_el_aventuroj_de_buratino';
import kantoElKorŝiraRomanco from './kanto_el_korŝira_romanco';
import kringetoj from './kringetoj';
import kanzonoPriInfanterio from './kanzono_pri_infanterio';
import kantoPriAfgano from './kanto_pri_afgano';
import noktaInterparolo from './nokta_interparolo.js';
import odesaKantoDeGankeviĉ from './odesa_kanto_de_gankeviĉ';
import petveture from './petveture';
import romancoPriBlankaAkacio from './romanco_pri_blanka_akacio';
import steleto from './steleto';
import ŝafeto from './ŝafeto';
import ŝipoj from './ŝipoj';
import turistaKanto from './turista_kanto';
import ukrainiajPopolajKantoj from './ukrainiaj_popolaj_kantoj';
import veturuNi from './veturu_ni_amata_mia';
import viKajMiKajKuneNi from './vi_kaj_mi_kaj_kune_ni';
import mihail_glinka from './mihail_glinka';
import hispana_bolero from './hispana_bolero';


const vera_matveeva = {
  itemName: {
    esp: 'Bardaj kantoj de Vera Matveeva'
  }
}

const list = [
  kantojElAventurojDeBuratino,
  {
    itemlink: getLink(vera_matveeva.itemName.esp),
    esp: {
      itemName: vera_matveeva.itemName.esp,
      isReactComponent: true,
      itemContentName: 'TKantojMatveeva'
    }
  },
  erinaco,
  kantoElKorŝiraRomanco,
  kantoPriOdeso,
  kringetoj,
  odesaKantoDeGankeviĉ,
  petveture,
  abiNaskiĝisEnArbar,
  diruHoMiaBela,
  himnoDeOdesaHumurfesto,
  radoDeLaFortun,
  kantoPriAfgano,
  noktaInterparolo,
  ŝafeto,
  ŝipoj,
  steleto,
  turistaKanto,
  ukrainiajPopolajKantoj,
  veturuNi,
  viKajMiKajKuneNi,
  juVizbor,
  juKukin,
  romancoPriBlankaAkacio,
  kanzonoPriInfanterio,
  kantoPriOdeso90,
  mihail_glinka,
  hispana_bolero
];

export default list;